export const TIPO_ARQUIVO_RELATORIO = {
  Excel: 'EXCEL',
  Csv: 'CSV',
} as const

export type TipoArquivoRelatorio = (typeof TIPO_ARQUIVO_RELATORIO)[keyof typeof TIPO_ARQUIVO_RELATORIO]

export const TIPO_RELATORIO = {
  Relatorio1: 'Relatorio1',
  Relatorio2: 'Relatorio2',
  Relatorio3: 'Relatorio3',
  Relatorio4: 'Relatorio4',
  Relatorio5: 'Relatorio5',
  Relatorio6: 'Relatorio6',
  Relatorio7: 'Relatorio7',
} as const

export type TipoRelatorio = (typeof TIPO_RELATORIO)[keyof typeof TIPO_RELATORIO]

export const tipoRelatorioOptions: { value: TipoRelatorio; label: string }[] = [
  { value: TIPO_RELATORIO.Relatorio1, label: 'Guias e Procedimentos emitidos' },
  { value: TIPO_RELATORIO.Relatorio2, label: 'Colaboradores logados' },
  { value: TIPO_RELATORIO.Relatorio3, label: 'Unidades logadas' },
  { value: TIPO_RELATORIO.Relatorio4, label: 'Colaboradores e acessos configurados' },
  { value: TIPO_RELATORIO.Relatorio5, label: 'Guias e Procedimentos emitidos por convênio' },
  { value: TIPO_RELATORIO.Relatorio6, label: 'Guias e Procedimentos emitidos por unidade' },
  { value: TIPO_RELATORIO.Relatorio7, label: 'Utilização do IVIA' },
]

export const tipoArquivoRelatorioOptions: { value: TipoArquivoRelatorio; label: string }[] = [
  { value: TIPO_ARQUIVO_RELATORIO.Excel, label: 'Excel' },
  { value: TIPO_ARQUIVO_RELATORIO.Csv, label: 'CSV' },
]

export interface GerarRelatorioFiltro {
  mes: string
  ano: string
  tipoArquivo: TipoArquivoRelatorio
  relatorio: TipoRelatorio
  pageNumber: number
  pageSize: number
}

export interface RelatorioArquivo {
  base64: string
  nomeArquivo: string
}
